<search-view objectName="BrokerContract" customTitle="searchView.brokerContractSearch" newObjectLabelKey="brokerContract.search.new"
             [dataProvider]="dataProvider" [enableSearchViewError]="true" [newButtonDisabled]="!userHasBrokerContractCreateRights()">
  <div class="search-criteria bon-card-group">
    <div class="bon-card-inner bon-label-180" style="width:25%">
      <input-row labelKey="brokerContract.search.criteria.number"
                 [(ngModel)]="dataProvider.searchCriteria.criteria.brokerContract.number"
                 name="number"></input-row>
      <checkbox-row labelKey="brokerContract.search.criteria.hasInsuranceContract"
                    [(ngModel)]="dataProvider.searchCriteria.criteria.hasPolicy"
                    name="hasPolicy" [nullable]="true"></checkbox-row>
      <checkbox-row labelKey="brokerContract.search.criteria.hasBondingContract"
                    [(ngModel)]="dataProvider.searchCriteria.criteria.hasContract"
                    name="hasContract" [nullable]="true" (changeState)="onContractChange()"></checkbox-row>
    </div>

    <div class="bon-card-inner bon-label-180" style="width:25%">
      <input-row labelKey="brokerContract.search.criteria.brokerName"
                 [(ngModel)]="dataProvider.searchCriteria.criteria.company.registrationName"
                 name="companyName"></input-row>
      <dict-row labelKey="brokerContract.search.criteria.type"
                [(ngModel)]="dataProvider.searchCriteria.criteria.brokerContract.brokerType"
                dictionary="BrokerType" nullLabel=" " name="name"></dict-row>
    </div>

    <div class="bon-card-inner bon-label-180" style="width:25%">
      <form-row labelKey="brokerContract.search.criteria.businessUnit">
        <business-unit-id-selector class="bon-input-size" nullLabel=" " [userDefaultBU]="false"
                                   [(ngModel)]="dataProvider.searchCriteria.criteria.businessUnit"
                                   name="businessUnit" [readonly]="false">
        </business-unit-id-selector>
      </form-row>
      <dict-row labelKey="brokerContract.search.criteria.country"
                [(ngModel)]="dataProvider.searchCriteria.criteria.company.address.country"
                dictionary="Country" nullLabel=" " name="country"></dict-row>
      <form-row label="brokerContract.search.criteria.version">
        <string-combo class="bon-input-size" [(ngModel)]="dataProvider.searchCriteria.criteria.versionPhase" nullLabel=" " [items]="versionPhases"></string-combo>
      </form-row>
    </div>
  </div>

  <div class="search-results">
    <a-table [pagination]="true" [pageSize]="20" [selection]="false" [dataProvider]="dataProvider"
             [sortable]='!dataProvider.textSearch' [showBackendErrors]="false">
      <column title="brokerContract.search.results.number" property="brokerContract.number"
              sort="brokerContract.number" [link]="true"
              (linkClick)="router.toBrokerContractPreview($event.id, 0)">
        <ng-template let-item="item">
          <span> {{item.brokerContract.number}}/{{item.versionNumber}}</span>
        </ng-template>
      </column>
      <column title="brokerContract.search.results.brokerName" property="brokerContract.company.registrationName"
              sort="brokerContract.company.registrationName" [link]="true"
              (linkClick)="router.toCompanyPreview($event.brokerContract.company.id)"></column>
      <column title="brokerContract.search.results.validFrom" property="validFrom" type="date" sort="validFrom"></column>
      <column title="brokerContract.search.results.validTo" property="validTo" type="date" sort="validTo"></column>
      <column title="brokerContract.search.results.bu" property="brokerContract.businessUnit.name"
              sort="brokerContract.businessUnit.name"></column>
      <column title="brokerContract.search.results.country" property="brokerContract.company.address.country.name"
              sort="brokerContract.company.address.country.name"></column>
    </a-table>
  </div>
</search-view>

